import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined'
import { Box, Container, IconButton, SxProps, Theme, Typography } from '@mui/material'

import { File } from 'common/interfaces'
import { FileRemove } from 'elements/FileUpload/common/commonInterfaces'
import { filePreviewBox } from 'elements/FileUpload/common/styles'
import readableBytes from 'elements/FileUpload/common/util'

const styles: Record<string, SxProps<Theme>> = {
  icon: {
    marginRight: '18.5px',
    width: '24px',
    height: '24px',
    color: 'rgba(0, 0, 0, 0.54)',
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    color: 'text.primary',
    '& p:first-of-type': {
      marginBottom: '-5px',
      maxWidth: {
        xs: '200px',
        sm: '350px',
      },
    },
    '& p:last-child': {
      marginTop: '-5px',
    },
  },
  secondaryColor: {
    color: 'text.secondary',
  },
}

interface FilePreviewProps extends FileRemove {
  file: File
}

export default function FilePreview({ file, onRemove }: FilePreviewProps): JSX.Element {
  const { name, extension, size } = file
  const { icon, info, secondaryColor } = styles

  return (
    <Box sx={filePreviewBox}>
      <InsertDriveFileOutlinedIcon sx={icon} />
      <Container sx={info} disableGutters>
        <Typography className="file-upload-name" noWrap>
          {name}
        </Typography>
        <Typography className="file-upload-data" sx={secondaryColor}>
          <span>{extension.toUpperCase()}</span> • <span>{readableBytes(size)}</span>
        </Typography>
      </Container>
      <IconButton sx={secondaryColor} onClick={onRemove}>
        <CancelOutlinedIcon />
      </IconButton>
    </Box>
  )
}
